"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/disclosure/disclosure-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, );
var useDisclosureContext = ctx.useContext;
var useDisclosureScopedContext = ctx.useScopedContext;
var useDisclosureProviderContext = ctx.useProviderContext;
var DisclosureContextProvider = ctx.ContextProvider;
var DisclosureScopedContextProvider = ctx.ScopedContextProvider;







exports.useDisclosureContext = useDisclosureContext; exports.useDisclosureScopedContext = useDisclosureScopedContext; exports.useDisclosureProviderContext = useDisclosureProviderContext; exports.DisclosureContextProvider = DisclosureContextProvider; exports.DisclosureScopedContextProvider = DisclosureScopedContextProvider;
